// extracted by mini-css-extract-plugin
export default {"button":"ToggleButton_button__SFwrK"};